import React from "react";
import { CallSplit, SubdirectoryArrowRight, TrendingFlat } from "@mui/icons-material";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

import { SpliceType } from "fond/types";

const spliceTypes = {
  express: {
    icon: <TrendingFlat data-testid="splice-type-express-icon" sx={{ fontSize: 22 }} />,
    description: "not split or spliced at this device.",
  },
  splice: {
    icon: <SubdirectoryArrowRight data-testid="splice-type-splice-icon" sx={{ fontSize: 22, transform: "translateX(2px)" }} />,
    description: "spliced here.",
  },
  split: {
    icon: <CallSplit data-testid="splice-type-split-icon" sx={{ fontSize: 22, transform: "rotate(90deg)" }} />,
    description: "split here.",
  },
};

interface IProps {
  // The type of splice occurring at this splicing row.
  spliceType: SpliceType | undefined;

  // Whether the splicing row refers to a single fiber, or multiple fibers.
  multiple: boolean;
}

/**
 * Icon representing the splice type of a splicing row.
 */
const SpliceTypeIcon: React.FC<IProps> = ({ spliceType, multiple }) => {
  if (!spliceType || spliceType === "dead" || spliceType === "spare" || !(spliceType in spliceTypes)) {
    // Ensure the icon always takes up a consistent amount of space.
    return <Icon data-testid="splice-type-empty-icon" />;
  }

  const { icon, description } = spliceTypes[spliceType];
  const prefix = multiple ? "These fibers are " : "This fiber is ";
  return <Tooltip title={prefix + description}>{icon}</Tooltip>;
};

export default SpliceTypeIcon;
